import React, { useEffect } from "react";
import querystring from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { logIn } from "auth/authActions";

const requiresAuthentication = Component => {
  const RequiresAuthentication = props => {
    const user = useSelector(state => state.auth.user);
    const dispatch = useDispatch();
    const location = useLocation();
    const token = user?.token;

    useEffect(() => {
      if (!token) {
        const searchParams = querystring.parse(location.search.substring(1));
        console.log(
          "Unauthorized, dispatching LOG_IN, redirectPath: %O, oAuthCode: %O",
          location.pathname,
          searchParams.code,
        );
        dispatch(logIn(location.pathname, searchParams.code));
      }
    }, [token, location, dispatch]);

    if (!token) return null;
    return <Component {...props} />;
  };

  return RequiresAuthentication;
};

export default requiresAuthentication;
